import React from "react";

import {
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

const ProjectPageHeader = ({
  title,
  description = null
}) => {
  if (!title && !description) {
    return null;
  }

  return (
    <Grid>
      <GridItem
        span={12}
        md={8}
        mdOffset={2}
      >
        <Stack hasGutter>
          {title && (
            <StackItem>
              <Content
                component="h1"
                style={{
                  textAlign: "center"
                }}
              >
                {title}
              </Content>
            </StackItem>
          )}

          {description && (
            <StackItem>
              <Content
                component="p"
                style={{
                  textAlign: "center"
                }}
              >
                {description}
              </Content>
            </StackItem>
          )}
        </Stack>
      </GridItem>
    </Grid>
  );
};

export default ProjectPageHeader;